export const ourWorkData = [
    {
        id: 1,
        title: "Vittaverse",
        description:
            "Vittaverse, spreads are competitively set in line with market conditions, ensuring fair and transparent pricing",
        img: "/assets/images/our-works-images/Vittaverse.webp",
        url: "/work/vittaverse",
    },
    {
        id: 2,
        title: "Upgaming",
        description:
            "Introducing the first interaction iGaming platfrom - A new discovery experience.",
        img: "/assets/images/our-works-images/Upgaming.webp",
        url: "/work/upgaming",
    },
    {
        id: 3,
        title: "Nespola",
        description:
            "Our mission is to make book publishing an accessible place for everyone. Learn how to publish any book",
        img: "/assets/images/our-works-images/Nespola.webp",
        url: "/work/nespola",
    },
    {
        id: 4,
        title: "Hyundai",
        description:
            "Awesome eco-friendly tech getting ready for the switch to electric cars!",
        img: "/assets/images/our-works-images/Hyundai.webp",
        url: "/work/hyundai",
    },
    {
        id: 5,
        title: "Mobu",
        description:
            "Barber App makes it super easy to book your hair appointment and skip the wait!",
        img: "/assets/images/our-works-images/Mobu.webp",
        url: "/work/mobu",
    },
    {
        id: 6,
        title: "Genie",
        description:
            "Not every social media app that launches is going to blow up, but there are definitely some tricks to help it along.",
        img: "/assets/images/our-works-images/Genie.webp",
        url: "/work/genie",
    },
    {
        id: 7,
        title: "Wooords",
        description:
            "Spruce up your kid's room with our fun collection of kids' prints and posters!",
        img: "/assets/images/our-works-images/Woords.webp",
        url: "/work/wooords",
    },
    {
        id: 8,
        title: "Farhly Go",
        description:
            "Check out FahrlyGO, the cool new tool for rental car drivers everywhere! With our game-changing Instant Notification!",
        img: "/assets/images/our-works-images/FarhlyGo.webp",
        url: "/work/fahrlygo",
    },
    {
        id: 9,
        title: "crypto Bitcoin",
        description:
            "The 2025 State of Crypto report shows some crazy highs in crypto activity and breaks down how it all works.",
        img: "/assets/images/our-works-images/Crypto.webp",
        url: "/work/crypto",
    },
    {
        id: 10,
        title: "GBG-Benefits",
        description:
            "Insurance Company Global Benefits Georgia Is An Exclusive Regional Representative ",
        img: "/assets/images/our-works-images/Benefits.webp",
        url: "/work/benefits",
    },
];  